import React, { Component } from 'react';
import { Carousel } from 'react-carousel-minimal';

class carousel extends Component {
  render() {
    return this.props.carouselData.length && this.props.sliderTimer ? (
      <>
        <Carousel
          key={this.props.carouselKey}
          data={this.props.carouselData}
          time={this.props.sliderTimer * 1000}
          width='100vw'
          height='100vh'
          slideNumber={false}
          automatic={true}
          dots={false}
          slideImageFit='cover'
          thumbnails={false}
          thumbnailWidth='0px'
          showNavBtn={false}
          style={{
            position: 'absolute',
            width: '100%',
            maxHeight: '100vh',
            margin: '0px auto',
            padding: '0px',
          }}
        />
      </>
    ) : null;
  }
}

export default carousel;
